import getCloudAPIHost from '../../get-cloud-api-host';
import { CloudAPI } from './types';

export const getUrlForLeaveRoom = (
    roomId: string,
    { peerId, peerToken, mediaSessionId }: CloudAPI.LeaveRoomOptions
): string => {
    const host = getCloudAPIHost();
    const path = `/telemost_front/v2/telemost/rooms/${roomId}/leave`;
    const search = `peer_id=${peerId}&peer_token=${peerToken}&media_session_id=${mediaSessionId}`;

    const result = new URL(host);
    result.pathname = path;
    result.search = search;

    return result.toString();
};
